import { useEffect, useRef } from 'react';

const useMounted = () => {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true; // ✅ Remet à true au montage

    return () => {
      isMounted.current = false; // ❌ Puis false au démontage
    };
  }, []);

  return isMounted;
};

export default useMounted;
